export enum FlowStateEnum {
  PROGRESS = 'IN_PROGRESS',
  FINISH = 'FINISHED',
  CANCEL = 'CANCELED'
}
